import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Delay = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <rect x="8" y="1" width="8" height="2" rx="1" fill={getColor(color, isColorInherited)} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6585 4.24744C20.0741 4.61112 20.1163 5.24288 19.7526 5.65852L18.6425 6.92723C20.1067 8.52793 21 10.6597 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02945 7.02944 4.00001 12 4.00001C13.91 4.00001 15.681 4.59497 17.1378 5.60966L18.2474 4.34151C18.6111 3.92587 19.2429 3.88375 19.6585 4.24744ZM12 7C11.4287 7 10.9468 7.4254 10.876 7.99228L10.2481 13.0154C10.1163 14.0692 10.938 15 12 15C13.062 15 13.8837 14.0692 13.7519 13.0154L13.124 7.99228C13.0532 7.4254 12.5713 7 12 7Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
